<template>
  <ConfirmationModal
    :entity="integration"
    :title="$t('DELETE_PLATFORM_INTEGRATION_MODAL_TITLE')"
    :cancel-button-text="$t('CANCEL')"
    :confirm-action-text="$t('DELETE')"
    :confirm-button-disabled="isFetchingReferences || isDeleting || (references && !attest)"
    :confirm-button-loading="isDeleting"
    @confirm="onConfirmDelete"
    @close="onCloseDeleteModal"
  >
    <div v-if="isFetchingReferences">
      <Loader custom-class="size-sm" />
      <span v-html="$t('DELETE_PLATFORM_INTEGRATION_MODAL_CHECK_ASSOCIATION_TEXT')"></span>
    </div>
    <div v-else>
      <p 
        v-if="!references"
        v-html="$t('DELETE_PLATFORM_INTEGRATION_MODAL_NONE_ASSOCIATION_TEXT', { integrationName })">
      </p>
      <div v-else>
        <p v-html="$t('DELETE_PLATFORM_INTEGRATION_MODAL_ASSOCIATION_TEXT', { integrationName })" class="m-b-10"></p>
        <div class="well well-sm m-b-10">
          <div class="form-horizontal">
            <div class="row">
              <label class="col-md-3 control-label">
                <strong>Campaigns</strong>
              </label>
              
              <div class="col-md-8">
                <ul class="list-unstyled form-control-static list-text-overflow">
                  <li v-for="(item, index) in references">
                    <a :href="`#/dashboard/campaign/${item.campaignId}`" target="_blank">
                      <span class="display-text">
                        {{ item.campaignName }}
                      </span>
                      <i class="fa fa-external-link m-l-5" aria-hidden="true" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="form-horizontal m-l-10 m-r-10">
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  v-model="attest"
                />
                <span v-t="'DELETE_PLATFORM_INTEGRATION_CHECKBOX'"></span>
              </label>
            </div>
        </div>
      </div>
    </div>
  </ConfirmationModal>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { mapActions, mapGetters } from 'vuex';
import { STATUS_ERROR, STATUS_SUCCESS, STATUS_PENDING } from '@/store/helpers';
import Loader from '@/core/components/Loader';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';

export default {
  name: 'PlatformDeleteModal',
  components: {
    ConfirmationModal,
    Loader
  },
  props: {
    integration: {
      type: Object,
      default() {
        return {};
      }
    },
    isDeleting: {
      type: Boolean,
      default: false
    }
  },  

  data() {
    return {
      references: null,
      attest: false
    };
  },
  computed: {
    ...mapGetters('platforms', [
      'getIntegrationReferencesStatus'
    ]),
    isFetchingReferences() {
      return this.getIntegrationReferencesStatus.status === STATUS_PENDING;
    },
    integrationName() {
      return this.integration?.name;
    }
  },
  async created() {
    if (this.integration) {
      try {
        const response = await this.getIntegrationReferences(this.integration);
        this.references = response.data.campaigns || null;
      } catch {
        utilities.errorHandler(this.getIntegrationReferencesStatus.error);
      }
    }
  },
  methods: {
    ...mapActions('platforms', [
      'getIntegrationReferences',
    ]),
    onConfirmDelete(){
      this.$emit('deleteIntegration', this.integration);
    },
    onCloseDeleteModal() {
      this.$emit('closeModal');
    }
  },
  
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>